import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  data: any = {};
  public locale: string = null;
  public loader: Promise<{}>;

  constructor(private http: HttpClient) {}

  use(lang: string): Promise<{}> {
    moment.locale(lang || 'en');
    lang = lang ? lang.toLowerCase() : 'en';
    return new Promise<{}>((resolve, reject) => {
      const langPath = `assets/i18n/${lang || 'en'}.json`;
      this.locale = lang;
      this.http.get<{}>(langPath).subscribe(
        (translation) => {
          this.data = translation;
          resolve(this.data);
          try {
            document.getElementById('loader').remove();
            document.getElementsByTagName('body')[0].classList.remove('preload');
          } catch (e) {}
        },
        (error) => {
          this.data = {};
          resolve(this.data);
          try {
            document.getElementById('loader').remove();
            document.getElementsByTagName('body')[0].classList.remove('preload');
          } catch (e) {}
        }
      );
    });
  }

  getData(): any {
    return this.data;
  }

  getLocale() {
    return this.locale;
  }
}
